import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
//Limitless imports
import Dialog from "@limitless/modern/feedback/dialog/Dialog";
const ConfirmRadioDialog = ({
  onSave,
  onCancel,
  usersCount,
  title,
  subtext,
  options
}) => {
  const [propValue, setPropValue] = React.useState(options[0].value);
  const renderRadioButtons = () => {
    return /*#__PURE__*/React.createElement(FormControl, {
      component: "fieldset",
      required: true,
      style: {
        marginTop: 16
      }
    }, /*#__PURE__*/React.createElement(RadioGroup, {
      name: "radio-group",
      value: propValue,
      onChange: event => setPropValue(event.target.value)
    }, options.map(item => /*#__PURE__*/React.createElement(FormControlLabel, {
      key: item.value,
      value: item.value,
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary",
        id: `${item.value}RadioButton`
      }),
      label: /*#__PURE__*/React.createElement(Typography, null, item.label)
    }))));
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    onClose: onCancel,
    title: title,
    onCancelClick: onCancel,
    onOkClick: () => onSave(propValue),
    okText: "Confirm",
    cancelVariant: "text",
    paperStyle: {
      maxWidth: "300px"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary"
  }, subtext.replace("{0}", usersCount)), renderRadioButtons());
};
export default ConfirmRadioDialog;
ConfirmRadioDialog.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  usersCount: PropTypes.number,
  title: PropTypes.string.isRequired,
  subtext: PropTypes.string.isRequired,
  options: PropTypes.array
};